const getFormItemLabelAboveConfiguration = labelAbove =>
  labelAbove ? { span: 24 } : undefined

export default getFormItemLabelAboveConfiguration
